import { Link } from 'react-router-dom';

export default function ProductsSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Premium Booths
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Choose from our signature offerings designed to elevate your event
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Overhead 360 Video Booth */}
          <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
            <div className="relative h-80 w-full">
              <img
                src="https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/0a9d24271904cef878dd65b5e3dc0b39.jpeg"
                alt="Overhead 360 Video Booth"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-4 right-4 bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
                Most Popular
              </div>
            </div>
            <div className="p-8">
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Overhead 360 Video Booth
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Experience the ultimate in event entertainment with our exclusive overhead 360 video booth. 
                Capture stunning slow-motion videos from every angle as your guests strike their best poses 
                on our premium platform. Perfect for weddings, corporate events, and celebrations.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-orange-500 text-xl mt-0.5"></i>
                  <span className="text-gray-700">360-degree overhead camera system</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-orange-500 text-xl mt-0.5"></i>
                  <span className="text-gray-700">Cinematic slow-motion effects</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-orange-500 text-xl mt-0.5"></i>
                  <span className="text-gray-700">Professional lighting setup</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-orange-500 text-xl mt-0.5"></i>
                  <span className="text-gray-700">Instant social media sharing</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-orange-500 text-xl mt-0.5"></i>
                  <span className="text-gray-700">Custom branding options</span>
                </li>
              </ul>
              <Link
                to="/overhead-360"
                className="block w-full text-center px-6 py-3 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Learn More
              </Link>
            </div>
          </div>

          {/* Signature Photo Booth */}
          <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
            <div className="relative h-80 w-full">
              <img
                src="https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/d8368ae9925b251b5819e38e1f1ebe93.jpeg"
                alt="Signature Photo Booth"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-8">
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Signature Photo Booth
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Our classic luxury photo booth delivers high-quality prints and digital photos that your 
                guests will treasure forever. Featuring professional equipment, fun props, and customizable 
                templates, it's the perfect addition to any celebration.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-orange-500 text-xl mt-0.5"></i>
                  <span className="text-gray-700">High-resolution photo prints</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-orange-500 text-xl mt-0.5"></i>
                  <span className="text-gray-700">Unlimited photo sessions</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-orange-500 text-xl mt-0.5"></i>
                  <span className="text-gray-700">Custom photo templates</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-orange-500 text-xl mt-0.5"></i>
                  <span className="text-gray-700">Fun props & backdrops</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-orange-500 text-xl mt-0.5"></i>
                  <span className="text-gray-700">Digital gallery access</span>
                </li>
              </ul>
              <Link
                to="/photo-booth"
                className="block w-full text-center px-6 py-3 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
